const writeLoadingDocument = (tab, message) => {
  try {
    tab.document.title = 'Opening...';
    tab.document.body.style.margin = '0';
    tab.document.body.style.fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
    tab.document.body.innerHTML = `
      <main style="min-height:100vh;display:grid;place-items:center;background:#f8fafc;color:#0f172a;">
        <p style="font-size:16px;">${message}</p>
      </main>
    `;
  } catch {
    // Some browsers restrict writes to about:blank windows. Navigation still works.
  }
};

export const openPendingNewTab = ({
  loadingMessage = 'Opening...',
  onBlocked,
} = {}) => {
  const tab = window.open('about:blank', '_blank');

  if (!tab) {
    return {
      blocked: true,
      navigate: (url) => {
        onBlocked?.();
        window.location.assign(url);
      },
      close: () => { },
    };
  }

  tab.opener = null;
  writeLoadingDocument(tab, loadingMessage);

  return {
    blocked: false,
    navigate: (url) => {
      tab.location.replace(url);
    },
    close: () => {
      tab.close();
    },
  };
};
